(function () {
  'use strict';

  angular.module('sempraWebapp').component('chemicalLevel', {
    templateUrl: 'app/facilityKarcherDetails/chemicalLevel/chemicalLevel.html',
    controller: chemicalLevel,
    bindings: {
      chemicalLevelData: '<',
      defaultVisibilityState: "<"
    },
    controllerAs: 'vm'
  });

  function chemicalLevel($translate) {
    var vm = this;

    vm.$onInit = function () {
      vm.visibilityState = vm.defaultVisibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.hideContent = function () {
      vm.visibilityState = !vm.visibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.mapServiceInfo = function(chemicalLevel, flag) {
      // with + operator convert string to number
      var toNumber = +chemicalLevel;
      switch (true) {
        case toNumber < 30 && toNumber > 4:
          return flag ? $translate.instant('LOW_CHEMICAL_LEVEL') : 'chemical-level-low-state';
        case toNumber < 5:
          return flag ? $translate.instant('EMPTY_CHEMICAL_LEVEL') : 'chemical-level-empty-state';
        default:
          return flag ? $translate.instant('NORMAL_CHEMICAL_LEVEL') : 'chemical-level-normal-state';
      }
    }

  }
})();
